(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kb-announcement"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kb-utility]').forEach(function (bar) {
  var cutoff = parseInt(bar.dataset.cutoff, 10) || 16;
  var label = bar.dataset.cutoffLabel || '2pm';
  var outs = bar.querySelectorAll('[data-kb-countdown]');

  function gulfNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
    var h = 0, m = 0;
    parts.forEach(function (p) { if (p.type === 'hour') h = parseInt(p.value, 10) % 24; if (p.type === 'minute') m = parseInt(p.value, 10); });
    return h * 60 + m;
  }
  function tick() {
    var left = cutoff * 60 - gulfNow();
    var html;
    if (left > 0) {
      var hh = Math.floor(left / 60), mm = left % 60;
      var time = (hh ? hh + (bar.dataset.tHours || 'h') + ' ' : '') + mm + (bar.dataset.tMinutes || 'm');
      html = (bar.dataset.tCountdown || 'Order within <strong>{time}</strong> for next-day delivery across the UAE').split('{time}').join(time);
    } else {
      html = (bar.dataset.tBefore || 'Next-day delivery across the UAE on orders before {time}').split('__TIME__').join(label).split('{time}').join(label);
    }
    outs.forEach(function (o) { o.innerHTML = html; });
  }
  tick();
  setInterval(tick, 30000);

  // constant reading speed: one item set scrolls past at ~45px per second, on any width
  var track = bar.querySelector('[data-kb-utility-track]');
  function speed() {
    var set = track && track.firstElementChild;
    if (!set) return;
    track.style.setProperty('--kb-utility-duration', Math.max(12, set.getBoundingClientRect().width / 45) + 's');
  }
  speed();
  window.addEventListener('resize', speed);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(speed);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.kb-bestsellers__rail').forEach(function (rail) {
    if (rail.dataset.kbReady) return;
    rail.dataset.kbReady = '1';
    var track = rail.querySelector('[data-kb-rail]');
    var prev = rail.querySelector('[data-kb-rail-prev]');
    var next = rail.querySelector('[data-kb-rail-next]');
    if (!track || !prev || !next) return;
    function step() {
      var slide = track.querySelector('.kb-bestsellers__slide');
      return slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    }
    function rtl() { return getComputedStyle(track).direction === 'rtl' ? -1 : 1; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = Math.abs(track.scrollLeft) <= 2;
      next.disabled = Math.abs(track.scrollLeft) >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * rtl(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * rtl(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kb-faq').forEach(function (sec) {
  sec.querySelectorAll('details.kb-faq__item').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        sec.querySelectorAll('details.kb-faq__item[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-guide-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.kb-guiderow__rail').forEach(function (rail) {
    if (rail.dataset.kbReady) return;
    rail.dataset.kbReady = '1';
    var track = rail.querySelector('[data-kb-guiderail]');
    var prev = rail.querySelector('[data-kb-guide-prev]');
    var next = rail.querySelector('[data-kb-guide-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.kb-guiderow__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    }
    function rtl() { return getComputedStyle(track).direction === 'rtl' ? -1 : 1; }
    function update() {
      prev.disabled = Math.abs(track.scrollLeft) <= 2;
      next.disabled = Math.abs(track.scrollLeft) >= track.scrollWidth - track.clientWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * rtl(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * rtl(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-legal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var links = document.querySelectorAll('.kb-legal__toc a');
  if (!links.length || !('IntersectionObserver' in window)) return;
  var map = {};
  links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && map[e.target.id]) {
        links.forEach(function (a) { a.classList.remove('is-active'); });
        map[e.target.id].classList.add('is-active');
      }
    });
  }, { rootMargin: '-15% 0px -70% 0px' });
  Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-main-collection"] && !Shopify.designMode) return;
  try {
    
var kbFilterForm = document.getElementById('kb-filterform');
var kbFilterSheet = document.getElementById('kb-filter-sheet');
var kbSort = document.getElementById('kb-sort');
var kbWide = window.matchMedia('(min-width: 990px)');
// From 990px the panel is an inline (non-modal) dialog that submits on every change. Below
// that it is a bottom sheet: choices wait for "Show results", and its sort pills replace the
// toolbar select while it is open (only one sort_by field may be enabled at a time).
function kbSheetSort(on) {
  if (!kbFilterForm) return;
  kbFilterForm.querySelectorAll('.kb-maincoll__sheetsort input').forEach(function (r) { r.disabled = !on; });
  if (kbSort) kbSort.disabled = on;
}
if (kbFilterForm) {
  kbFilterForm.addEventListener('change', function (e) {
    if (kbFilterSheet && kbFilterSheet.matches(':modal')) return;
    kbFilterForm.submit();
  });
}
if (kbFilterSheet) {
  kbFilterSheet.addEventListener('kb:sheet-open', function () { kbSheetSort(true); });
  kbFilterSheet.addEventListener('kb:sheet-close', function () { kbSheetSort(false); });
  var kbLayout = function () {
    if (kbWide.matches) {
      if (kbFilterSheet.matches(':modal') && window.kbSheets) window.kbSheets.close(kbFilterSheet);
      if (!kbFilterSheet.open) kbFilterSheet.show();
    }
  };
  kbWide.addEventListener('change', function () { setTimeout(kbLayout, 260); });
}
if (kbSort && kbFilterForm) {
  kbSort.addEventListener('change', function () { kbFilterForm.submit(); });
} else if (kbSort) {
  kbSort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', kbSort.value);
    window.location.href = url.toString();
  });
}
// mobile: brands render inside the chip row, so the <details> must be open there
if (window.matchMedia('(max-width: 989px)').matches) {
  document.querySelectorAll('.kb-maincoll__brands').forEach(function (d) { d.open = true; });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-description"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kb-tabs]').forEach(function (root) {
  root.classList.add('is-js');
  var tabs = root.querySelectorAll('.kb-ptabs__tab');
  var panels = root.querySelectorAll('.kb-ptabs__panel');

  function activate(key) {
    tabs.forEach(function (t) {
      var on = t.dataset.tab === key;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === key);
    });
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(t.dataset.tab); });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
      tabs[next].focus();
      activate(tabs[next].dataset.tab);
    });
  });

  root.querySelectorAll('.kb-ptabs__acc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.kb-ptabs__panel');
      var open = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kb-pfaq').forEach(function (sec) {
  sec.querySelectorAll('details.kb-faq__item').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        sec.querySelectorAll('details.kb-faq__item[open]').forEach(function (other) {
          if (other !== d) other.open = false;
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-main"] && !Shopify.designMode) return;
  try {
    
const main = document.getElementById('kb-gallery-main');
document.querySelectorAll('.kb-pmain__thumb').forEach((btn) => {
  btn.addEventListener('click', () => {
    if (main) main.src = btn.dataset.full;
    document.querySelectorAll('.kb-pmain__thumb').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
});
const variantSelect = document.getElementById('kb-variant');
const skuEl = document.querySelector('[data-kb-sku]');
if (variantSelect && skuEl) {
  variantSelect.addEventListener('change', () => {
    const opt = variantSelect.options[variantSelect.selectedIndex];
    if (opt && opt.dataset.sku) skuEl.textContent = opt.dataset.sku;
  });
}
const sticky = document.getElementById('kb-sticky');
const buybox = document.querySelector('.kb-pmain__buybox');
if (sticky && buybox && 'IntersectionObserver' in window) {
  new IntersectionObserver(
    (entries) => { sticky.hidden = entries[0].isIntersecting; },
    { rootMargin: '-80px 0px 0px 0px' }
  ).observe(buybox);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-related"] && !Shopify.designMode) return;
  try {
    
const related = document.getElementById('kb-related');
if (related && related.dataset.url && !related.querySelector('.kb-grid')) {
  fetch(related.dataset.url)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('kb-related');
      if (fresh && fresh.querySelector('.kb-grid')) related.innerHTML = fresh.innerHTML;
    })
    .catch(() => {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-product-routine"] && !Shopify.designMode) return;
  try {
    
const addAll = document.getElementById('kb-add-routine');
if (addAll) {
  addAll.addEventListener('click', async () => {
    const ids = addAll.dataset.variants.split(',').filter(Boolean);
    addAll.disabled = true;
    addAll.textContent = addAll.dataset.adding || 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
      });
      if (!res.ok) throw new Error('add failed');
      addAll.textContent = (addAll.dataset.added || 'Added') + ' ✓';
      window.location.href = '/cart';
    } catch (e) {
      addAll.textContent = addAll.dataset.label || 'Add routine to bag';
      addAll.disabled = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-routine-band"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-routine-add]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var ids = btn.dataset.variants.split(',').filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = btn.dataset.adding || 'Adding…';
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var reset = function () { btn.disabled = false; btn.textContent = original; };
    // KB cart: add without leaving the page and open the bag (it shows its own error toast)
    if (window.kbCart) { window.kbCart.add(items).then(reset, reset); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        alert(btn.dataset.error || 'Sorry, something went wrong adding the routine. Please try again.');
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-routine-steps"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kb-routinesteps [data-routine-add]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var ids = btn.dataset.variants.split(',').filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = btn.dataset.adding || 'Adding…';
    var items = ids.map(function (id) { return { id: Number(id), quantity: 1 }; });
    var reset = function () { btn.disabled = false; btn.textContent = original; };
    // KB cart: add without leaving the page and open the bag
    if (window.kbCart) { window.kbCart.add(items).then(reset, reset); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        alert(btn.dataset.error || 'Sorry, something went wrong adding the routine. Please try again.');
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-skin-quiz"] && !Shopify.designMode) return;
  try {
    
const quiz = document.getElementById('kb-quiz');
if (quiz) {
  const config = JSON.parse(quiz.querySelector('[data-quiz-config]').textContent);
  const screens = {
    intro: quiz.querySelector('[data-screen="intro"]'),
    question: quiz.querySelector('[data-screen="question"]'),
    result: quiz.querySelector('[data-screen="result"]'),
  };
  const questions = [...quiz.querySelectorAll('[data-question]')];
  const counter = quiz.querySelector('[data-quiz-counter]');
  const bar = quiz.querySelector('[data-quiz-bar]');
  let current = 0;
  const tally = {};

  const show = (name) => {
    Object.values(screens).forEach((s) => (s.hidden = true));
    screens[name].hidden = false;
    quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const renderQuestion = () => {
    questions.forEach((q, i) => (q.hidden = i !== current));
    counter.textContent = (counter.dataset.template || 'Question __C__ of __T__').replace('__C__', current + 1).replace('__T__', questions.length);
    bar.style.width = `${((current + 1) / questions.length) * 100}%`;
  };

  quiz.querySelector('[data-quiz-start]').addEventListener('click', () => {
    show('question');
    renderQuestion();
  });

  quiz.querySelectorAll('.kb-quiz__answer').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.concern;
      if (key) tally[key] = (tally[key] || 0) + 1;
      if (current < questions.length - 1) {
        current += 1;
        renderQuestion();
      } else {
        const winner = Object.keys(tally).sort((a, b) => tally[b] - tally[a])[0] || 'dryness';
        const data = config[winner] || {};
        quiz.querySelector('[data-result-heading]').textContent = data.label || quiz.querySelector('[data-result-heading]').dataset.fallback || 'Your routine';
        quiz.querySelector('[data-result-text]').textContent = data.text || '';
        quiz.querySelector('[data-result-link]').href = data.url || '/collections';
        show('result');
      }
    });
  });

  quiz.querySelector('[data-quiz-restart]').addEventListener('click', () => {
    current = 0;
    Object.keys(tally).forEach((k) => delete tally[k]);
    show('question');
    renderQuestion();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-tiers"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.kb-tiers__cta').forEach((btn) => {
  btn.addEventListener('click', async () => {
    const ids = btn.dataset.variants.split(',').filter(Boolean);
    if (!ids.length) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.adding || 'Adding…';
    const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
    // KB cart: add without leaving the page and open the bag
    if (window.kbCart) {
      const reset = () => { btn.textContent = original; btn.disabled = false; };
      window.kbCart.add(items).then(reset, reset);
      return;
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
      });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = (btn.dataset.added || 'Added') + ' ✓';
      window.location.href = '/cart';
    } catch (e) {
      btn.textContent = original;
      btn.disabled = false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kb-trust-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-kb-trustbar]').forEach(function (track) {
    if (track.dataset.kbReady) return;
    track.dataset.kbReady = '1';
    var items = track.children;
    var dots = track.parentElement.querySelectorAll('.kb-trustbar__dot');
    if (items.length < 2) return;
    var idx = 0, timer = null, resumeAt = 0, visible = true;
    function current() { return Math.round(Math.abs(track.scrollLeft) / Math.max(1, track.clientWidth)); }
    function paint(i) { dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); }); }
    function go(i) { idx = (i + items.length) % items.length; track.scrollTo({ left: idx * track.clientWidth * (getComputedStyle(track).direction === 'rtl' ? -1 : 1), behavior: 'smooth' }); paint(idx); }
    track.addEventListener('scroll', function () { var i = current(); if (i !== idx) { idx = i; paint(i); } }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { resumeAt = Date.now() + 6000; }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(track);
    }
    function tick() {
      if (!mq.matches || still.matches || !visible || document.hidden || Date.now() < resumeAt) return;
      go(idx + 1);
    }
    timer = setInterval(tick, 3500);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
